import React from 'react'
import "./loader.scss"

const Loader = () => {
  return (
    <>
    <div className='noise-div'></div>
    <div className="loader-wrapper">
        <h1>Loading</h1>
        <div className="loader-block">
            <div className="line">
                <div className="inner-line"></div>
            </div>
        </div>
    </div>
    </>
    
  )
}

export default Loader